export const newsletter = {
  success: {
    created: 'Newsletter created successfully',
    updated: 'Newsletter updated successfully',
    deleted: 'Newsletter deleted successfully',
    deletedMultiple: 'Deleted {{count}} newsletters successfully',
    published: 'Published {{count}} newsletters successfully',
    statusUpdated: 'Newsletter {{status}}ed successfully',
    syncedToWordPress: 'Newsletter synced to WordPress successfully!',
    syncedToWordPressWithPost: 'Newsletter synced to WordPress successfully! Post ID: {{postId}}',
    savedToDevice: 'Saved a copy to your device',
    savedAllToDevice: 'Saved {{count}} newsletters to your device',
    imported: 'Imported {{count}} newsletters',
    sent: '{{message}}',
    addedToCampaign: '{{message}}',
    retriedFailed: 'Resent {{count}} previously failed email(s) successfully',
  },
  errors: {
    selectToDelete: 'Please select newsletters to delete',
    selectToPublish: 'Please select newsletters to publish',
    cannotPublish: 'Cannot publish {{count}} newsletter(s) - only draft newsletters can be published',
    selectToAddToCampaign: 'Please select newsletters to add to campaign',
    saveToDeviceFailed: 'Could not save a copy to your device',
    retryFailed: 'Failed to resend: {{error}}',
    retryFailedPartial:
      'Resent {{successCount}} email(s); {{failureCount}} still failed',
  },
  warnings: {
    importCompletedWithErrors: 'Import completed with {{count}} errors',
  },
}
